export default __webpack_public_path__ + "static/apple-app-store-badge-1de917769bcfafefb0fa5f6f9de74c87.svg";